class ShowPhoneNumber {
	constructor() {
		this.phoneBtn = document.querySelectorAll('.telephone');

		this.show();
	}

	show() {
		this.phoneBtn.forEach(btn => {
			if (btn.tagName === 'SPAN') {
				btn.setAttribute('data-trk-click-tel', btn.innerText);
			} else {
				btn.setAttribute('data-trk-click-tel', btn.querySelector('a').innerText);
			}
			btn.addEventListener('click', () => {
				btn.classList.add('show-phone');
			});
		});
	}
}
